module.exports = __webpack_public_path__ + "img/6.00f8e856.webp";